"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeductionTemplateExecutionStrategy = exports.DeductionType = exports.DeductionStatus = void 0;
var DeductionStatus;
(function (DeductionStatus) {
    DeductionStatus["Pending"] = "Pending";
    DeductionStatus["PartiallyApplied"] = "PartiallyApplied";
    DeductionStatus["Complete"] = "Complete";
})(DeductionStatus = exports.DeductionStatus || (exports.DeductionStatus = {}));
var DeductionType;
(function (DeductionType) {
    DeductionType["PrePayment"] = "PrePayment";
    DeductionType["PostPayment"] = "PostPayment";
})(DeductionType = exports.DeductionType || (exports.DeductionType = {}));
var DeductionTemplateExecutionStrategy;
(function (DeductionTemplateExecutionStrategy) {
    DeductionTemplateExecutionStrategy["PayablePayment"] = "PayablePayment";
})(DeductionTemplateExecutionStrategy = exports.DeductionTemplateExecutionStrategy || (exports.DeductionTemplateExecutionStrategy = {}));
//# sourceMappingURL=deductions.js.map